export const COOKIE_VALUES = {
  userSignUpStatusPending: 'pending',
  userSignUpStatusRegistered: 'registered',
  signUpStatusSessionExpired: 'session_expired',
  signUpStatusCreatingAccount: 'creating_account',
  signUpStepSelectingPlan: 'selecting_plan',
  signUpStepCreateingAccount: 'createing_account',
  signUpStepPayment: 'payment'
};

export enum ANALYTICS_CONSENT {
  ACCEPTED = 'accepted',
  REJECTED = 'rejected'
}
